/* eslint-disable no-unused-expressions */
import { useMemo, useEffect, useRef } from 'react';

export const useInitializeStripe = (paymentMethods, options) => {
    const { onClose, onToken } = options || {};
    const state = useMemo(() => {
        const stripe = paymentMethods.find(p => p.code.startsWith('stripe'));
        const state = {};

        if (stripe && stripe.configs) {
            state.shouldLoadStripe = true;
            state.configs = stripe.configs;
            state.is3dsEnabled = stripe.configs.is3dsEnabled === 'true';
        }

        return state;
    }, [paymentMethods]);

    const stripeHandlerRef = useRef(null);

    useEffect(() => {
        if (typeof document === 'undefined') return;
        if (!state.shouldLoadStripe) return;

        const script = document.createElement('script');
        script.async = true;

        if (state.is3dsEnabled) {
            script.src = 'https://js.stripe.com/v3';
            script.onload = () => {
                const stripe = Stripe(state.configs.publicKey);
                stripeHandlerRef.current = stripe; // store if needed
            };
        } else {
            script.src = 'https://checkout.stripe.com/checkout.js';
            script.onload = () => {
                const handler = StripeCheckout.configure({
                    key: state.configs.publicKey,
                    closed: onClose,
                    token: function(token) {
                        state.stripeIsTokenUsed = true;
                        onToken?.(token);
                    }
                });
                stripeHandlerRef.current = handler;
            };
        }

        document.body.appendChild(script);

        return () => {
            const scripts = document.querySelectorAll('script[src*="stripe"]');
            scripts.forEach(script => script.parentNode?.removeChild(script));

            if (stripeHandlerRef.current?.close) {
                stripeHandlerRef.current.close();
            }
            stripeHandlerRef.current = null;
        };
    }, [state.shouldLoadStripe, state.is3dsEnabled, state.configs, onClose, onToken]);

    return state;
};
